import { State } from '@state/model';

export const selectBTax = (state: State) => state.common.btax;
export const selectBTaxSupportedByState = (state: State) => state.common.btax.supportedByState;
